/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/IStripeAccountBean', 'model/StripeAccountMetadataBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./IStripeAccountBean'), require('./StripeAccountMetadataBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.StripeAccountResponse = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.IStripeAccountBean, root.BpmbuildProductionappspotcom.StripeAccountMetadataBean);
  }
}(this, function(ApiClient, IStripeAccountBean, StripeAccountMetadataBean) {
  'use strict';

  /**
   * The StripeAccountResponse model module.
   * @module model/StripeAccountResponse
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeAccountResponse</code>.
   * @alias module:model/StripeAccountResponse
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeAccountResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeAccountResponse} obj Optional instance to populate.
   * @return {module:model/StripeAccountResponse} The populated <code>StripeAccountResponse</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('stripeType'))
        obj.stripeType = ApiClient.convertToType(data['stripeType'], 'String');
      if (data.hasOwnProperty('settingsCardPayments'))
        obj.settingsCardPayments = ApiClient.convertToType(data['settingsCardPayments'], 'String');
      if (data.hasOwnProperty('externalAccounts'))
        obj.externalAccounts = ApiClient.convertToType(data['externalAccounts'], 'String');
      if (data.hasOwnProperty('capabilitiesLegacyPayments'))
        obj.capabilitiesLegacyPayments = ApiClient.convertToType(data['capabilitiesLegacyPayments'], 'String');
      if (data.hasOwnProperty('settingsPayments'))
        obj.settingsPayments = ApiClient.convertToType(data['settingsPayments'], 'String');
      if (data.hasOwnProperty('capabilitiesCardPayments'))
        obj.capabilitiesCardPayments = ApiClient.convertToType(data['capabilitiesCardPayments'], 'String');
      if (data.hasOwnProperty('payoutsEnabled'))
        obj.payoutsEnabled = ApiClient.convertToType(data['payoutsEnabled'], 'Boolean');
      if (data.hasOwnProperty('company'))
        obj.company = ApiClient.convertToType(data['company'], 'String');
      if (data.hasOwnProperty('metaData'))
        obj.metaData = StripeAccountMetadataBean.constructFromObject(data['metaData']);
      if (data.hasOwnProperty('stripeAccountId'))
        obj.stripeAccountId = ApiClient.convertToType(data['stripeAccountId'], 'String');
      if (data.hasOwnProperty('individual'))
        obj.individual = ApiClient.convertToType(data['individual'], 'String');
      if (data.hasOwnProperty('settingsPayouts'))
        obj.settingsPayouts = ApiClient.convertToType(data['settingsPayouts'], 'String');
      if (data.hasOwnProperty('capabilitiesPlatformPayments'))
        obj.capabilitiesPlatformPayments = ApiClient.convertToType(data['capabilitiesPlatformPayments'], 'String');
      if (data.hasOwnProperty('settingsBranding'))
        obj.settingsBranding = ApiClient.convertToType(data['settingsBranding'], 'String');
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
      if (data.hasOwnProperty('requirementsCurrentDeadline'))
        obj.requirementsCurrentDeadline = ApiClient.convertToType(data['requirementsCurrentDeadline'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('requirementPastDue'))
        obj.requirementPastDue = ApiClient.convertToType(data['requirementPastDue'], 'String');
      if (data.hasOwnProperty('country'))
        obj.country = ApiClient.convertToType(data['country'], 'String');
      if (data.hasOwnProperty('requirementsDisabledReason'))
        obj.requirementsDisabledReason = ApiClient.convertToType(data['requirementsDisabledReason'], 'String');
      if (data.hasOwnProperty('stripeAccountType'))
        obj.stripeAccountType = ApiClient.convertToType(data['stripeAccountType'], 'String');
      if (data.hasOwnProperty('businessType'))
        obj.businessType = ApiClient.convertToType(data['businessType'], 'String');
      if (data.hasOwnProperty('defaultCurrency'))
        obj.defaultCurrency = ApiClient.convertToType(data['defaultCurrency'], 'String');
      if (data.hasOwnProperty('errorCode'))
        obj.errorCode = ApiClient.convertToType(data['errorCode'], 'Number');
      if (data.hasOwnProperty('settingsDashboard'))
        obj.settingsDashboard = ApiClient.convertToType(data['settingsDashboard'], 'String');
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('requirementsCurrentlyDue'))
        obj.requirementsCurrentlyDue = ApiClient.convertToType(data['requirementsCurrentlyDue'], 'String');
      if (data.hasOwnProperty('businessProfile'))
        obj.businessProfile = ApiClient.convertToType(data['businessProfile'], 'String');
      if (data.hasOwnProperty('requirementEventuallyDue'))
        obj.requirementEventuallyDue = ApiClient.convertToType(data['requirementEventuallyDue'], 'String');
      if (data.hasOwnProperty('stripeAccountList'))
        obj.stripeAccountList = ApiClient.convertToType(data['stripeAccountList'], [IStripeAccountBean]);
      if (data.hasOwnProperty('tosAcceptance'))
        obj.tosAcceptance = ApiClient.convertToType(data['tosAcceptance'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('detailsSubmitted'))
        obj.detailsSubmitted = ApiClient.convertToType(data['detailsSubmitted'], 'Boolean');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('chargesEnabled'))
        obj.chargesEnabled = ApiClient.convertToType(data['chargesEnabled'], 'Boolean');
      if (data.hasOwnProperty('responseMsg'))
        obj.responseMsg = ApiClient.convertToType(data['responseMsg'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} stripeType
   */
  exports.prototype.stripeType = undefined;

  /**
   * @member {String} settingsCardPayments
   */
  exports.prototype.settingsCardPayments = undefined;

  /**
   * @member {String} externalAccounts
   */
  exports.prototype.externalAccounts = undefined;

  /**
   * @member {String} capabilitiesLegacyPayments
   */
  exports.prototype.capabilitiesLegacyPayments = undefined;

  /**
   * @member {String} settingsPayments
   */
  exports.prototype.settingsPayments = undefined;

  /**
   * @member {String} capabilitiesCardPayments
   */
  exports.prototype.capabilitiesCardPayments = undefined;

  /**
   * @member {Boolean} payoutsEnabled
   */
  exports.prototype.payoutsEnabled = undefined;

  /**
   * @member {String} company
   */
  exports.prototype.company = undefined;

  /**
   * @member {module:model/StripeAccountMetadataBean} metaData
   */
  exports.prototype.metaData = undefined;

  /**
   * @member {String} stripeAccountId
   */
  exports.prototype.stripeAccountId = undefined;

  /**
   * @member {String} individual
   */
  exports.prototype.individual = undefined;

  /**
   * @member {String} settingsPayouts
   */
  exports.prototype.settingsPayouts = undefined;

  /**
   * @member {String} capabilitiesPlatformPayments
   */
  exports.prototype.capabilitiesPlatformPayments = undefined;

  /**
   * @member {String} settingsBranding
   */
  exports.prototype.settingsBranding = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  /**
   * @member {String} requirementsCurrentDeadline
   */
  exports.prototype.requirementsCurrentDeadline = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} requirementPastDue
   */
  exports.prototype.requirementPastDue = undefined;

  /**
   * @member {String} country
   */
  exports.prototype.country = undefined;

  /**
   * @member {String} requirementsDisabledReason
   */
  exports.prototype.requirementsDisabledReason = undefined;

  /**
   * @member {String} stripeAccountType
   */
  exports.prototype.stripeAccountType = undefined;

  /**
   * @member {String} businessType
   */
  exports.prototype.businessType = undefined;

  /**
   * @member {String} defaultCurrency
   */
  exports.prototype.defaultCurrency = undefined;

  /**
   * @member {Number} errorCode
   */
  exports.prototype.errorCode = undefined;

  /**
   * @member {String} settingsDashboard
   */
  exports.prototype.settingsDashboard = undefined;

  /**
   * @member {String} created
   */
  exports.prototype.created = undefined;

  /**
   * @member {String} email
   */
  exports.prototype.email = undefined;

  /**
   * @member {String} requirementsCurrentlyDue
   */
  exports.prototype.requirementsCurrentlyDue = undefined;

  /**
   * @member {String} businessProfile
   */
  exports.prototype.businessProfile = undefined;

  /**
   * @member {String} requirementEventuallyDue
   */
  exports.prototype.requirementEventuallyDue = undefined;

  /**
   * @member {Array.<module:model/IStripeAccountBean>} stripeAccountList
   */
  exports.prototype.stripeAccountList = undefined;

  /**
   * @member {String} tosAcceptance
   */
  exports.prototype.tosAcceptance = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Boolean} detailsSubmitted
   */
  exports.prototype.detailsSubmitted = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Boolean} chargesEnabled
   */
  exports.prototype.chargesEnabled = undefined;

  /**
   * @member {String} responseMsg
   */
  exports.prototype.responseMsg = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/StripeAccountResponse.js